import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Home from "./pages/Home";
import LogoDownload from "./pages/LogoDownload";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import RefundPolicy from "./pages/RefundPolicy";
import AboutUs from "./pages/AboutUs";
import EditorialPolicy from "./pages/EditorialPolicy";
import { CompareProvider } from "./context/CompareContext";
import { Phone } from 'lucide-react';

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        {/* Black Top Bar */}
        <div className="bg-black text-white py-2 px-4 text-center text-sm">
          <div className="container mx-auto flex flex-wrap items-center justify-center gap-4">
            <span className="flex items-center gap-2">
              <Phone className="w-4 h-4" />
              Free helpline: <a href="tel:08006521866" className="font-bold hover:text-blue-400">0800 652 1866</a>
            </span>
            <span className="hidden sm:inline">|</span>
            <span>Independent UK Mobile & Internet Support</span>
            <span className="hidden sm:inline">|</span>
            <span className="text-blue-400 font-semibold">Call Now — No Wait</span>
          </div>
        </div>
        
        <CompareProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/logo-download" element={<LogoDownload />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-conditions" element={<TermsConditions />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/editorial-policy" element={<EditorialPolicy />} />
            </Routes>
          </BrowserRouter>
        </CompareProvider>
      </div>
    </HelmetProvider>
  );
}

export default App;
